export default function scrollToForm() {
    if (!!window.location.search && !window.location.hash) {
        const search = window.location.search.match(/query-[0-9]*-[A-z|\-]*/)
        if (search.length) {
            const matchedInput = document.getElementById(search[0]);
            if (matchedInput) {
                matchedInput.scrollIntoView()
            }
        }
    }
}
